import React, { useContext, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { pxToRem } from '../../../lib/_util/UnitConvertor';
import TableContext from './TableContext';
const VirtualWrapper = observer((props) => {
    const { children } = props;
    const { tableStore: { virtualTop, virtualHeight, prefixCls }, } = useContext(TableContext);
    const style = useMemo(() => ({ transform: `translate(0, ${pxToRem(virtualTop)})` }), [virtualTop]);
    return (React.createElement("div", { className: `${prefixCls}-tbody-wrapper`, style: { height: pxToRem(virtualHeight) } },
        React.createElement("div", { style: style }, children)));
});
export default VirtualWrapper;
